import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { PreferencesResponse } from "../models/orders";

import {
  derivativeOrderPreferencesMapper,
  equityOrderPreferencesMapper,
} from "../utils/orders.helper";

const initialState: PreferencesResponse = {
  // for Orders
  equityOrderPreferences: "intraday",
  derivativeOrderPreferences: "delivery",
  orderType: "market",
  // modifies orders code
  equityPreference: "CarryForward",
  derivatePreference: "CarryForward",

  // Now for Smart Order Preferences
  smartOrderPreferences: {
    gtt: false,
    gttOrderPreference: {
      limit: false,
      market: false,
      stoploss: false,
      target: false,
      // single: false,
    },
    iceBerg: false,
    reduceMargin: false,
    splitOrder: false,
  },
};

const OrderPreferenceSlice = createSlice({
  name: "orderPreference",
  initialState,
  reducers: {
    setOrderPreference(state, action: PayloadAction<PreferencesResponse>) {
      return {
        // this is onlt for Orders
        equityOrderPreferences: action.payload.equityOrderPreferences,
        derivativeOrderPreferences: action.payload.derivativeOrderPreferences,
        orderType: action.payload.orderType,
        // modifies orders code
        equityPreference: equityOrderPreferencesMapper(
          action.payload.equityOrderPreferences ?? "delivery"
        ),
        derivatePreference: derivativeOrderPreferencesMapper(
          action.payload.derivativeOrderPreferences ?? "delivery"
        ),
        // Smart Order Preferences
        smartOrderPreferences: action.payload.smartOrderPreferences,
      }; // This replaces the entire state
    },
  },
});

export const { setOrderPreference } = OrderPreferenceSlice.actions;

export default OrderPreferenceSlice.reducer;
